/* Move the hero's "at a glance" box below the enrol box on phones.

   The four cells (state requirement / course structure / avg. completion /
   course final) are useful reference, but they are reference — not the reason
   someone is on the page. Stacked one-up at 375px the box is 556px tall: 0.68
   of a screen, and 56% of the hero's whole 999px height. It sits between the
   lede and the enrol rail, so it is most of what pushes the price and the
   three package options to y 1,302 — 1.6 screens down — while on desktop the
   rail is absolutely positioned beside the hero and all of it is visible
   immediately. That gap is the measured one: this URL bounces at 79.6% on
   mobile against 58.3% on desktop.

   So on phones the buyer meets price and packages first, and the reference
   facts sit directly under them.

   Progressive enhancement: with JavaScript off, or above the breakpoint, the
   box stays exactly where the Liquid put it. The node is moved, never
   duplicated, so there is only ever one copy in the DOM. */
(function () {
  'use strict';

  var MQ = '(max-width: 1040px)';   // matches pc-enroll.js's own mobile test
  var mql = window.matchMedia(MQ);
  var box = null;
  var anchor = null;                // marks where the box lives on desktop
  var rail = null;

  function apply() {
    if (!box || !rail || !anchor) return;

    if (mql.matches) {
      // Below the enrol box. insertBefore(null) appends, which is what we want
      // when the rail is the last child of its parent.
      if (box.previousElementSibling !== rail || box.parentNode !== rail.parentNode) {
        rail.parentNode.insertBefore(box, rail.nextSibling);
      }
      box.classList.add('pc-summary-box--relocated');
    } else {
      if (box.previousSibling !== anchor) {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
      box.classList.remove('pc-summary-box--relocated');
    }
  }

  function init() {
    box = document.querySelector('.pc-summary-box');
    rail = document.querySelector('.pc-course-rail-section');
    // No rail on this template (e.g. the generic course product template) —
    // there is nothing to move it below, so leave the hero alone.
    if (!box || !rail || box.dataset.pcMoved === '1') return;

    if (box.getAttribute('data-pc-relocate') === 'off') return;

    anchor = document.createComment('summary-box home');
    box.parentNode.insertBefore(anchor, box);
    box.dataset.pcMoved = '1';

    apply();
    if (mql.addEventListener) mql.addEventListener('change', apply);
    else if (mql.addListener) mql.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    box = null;
    anchor = null;
    init();
  });
})();
